const easing = 'ease-in-out';
const transitions = {
    short: `150ms ${easing}`,
    default: `200ms ${easing}`,
    long: `500ms ${easing}`,
};
export default transitions;
//# sourceMappingURL=transitions.js.map